import React, { useEffect, useState } from "react";
import { Button, Col, Row } from "react-bootstrap";
import { toast } from "react-toastify";
import useApiClient, { apiRoutes } from "../../../hooks/apiClient";
// import useClonar from "./hooks/useClonar";
// import useRevisao from "./hooks/useRevisao";
import HtmlToString from "../../../components/Formatters/HtmlToString";
import OverlayInfoAdicional from "../../../components/UI/Overlays/OverlayInfoAdicional";

const ConsultaOcorrenciaDetalhes = ({ location, sqTipoOcorrencia, history, handleVoltar }) => {
  const { texto } = useState();
  const { state } = location;
  const [dados, setDados] = useState({});
  const [dadosInfo, setDadosInfo] = useState({});

  // Alterar Status Revisão
  // const { Revisar } = useRevisao();

  // Clonar Ocorrência
  // const { idOcorrencia, Clonar } = useClonar();

  const fcTipoMercadoria = (condicao) => {
    switch (condicao) {
      case "T":
        return "TRIBUTADA";
      case "I":
        return "INSENTA";
      case "N":
        return "NÃO TRIBUTADA";
      case "S":
        return "SUBSTITUIÇÃO TRIBUTÁRIA";
      case "A":
        return "NÃO SE APLICA";
      default:
        return "-";
    }
  };

  // Carregar item
  const {
    request: consultaFormRequest,
    data: consultaFormData,
    errors: consultaFormErrors,
    isLoading: consultaFormIsLoading,
  } = useApiClient();

  // useEffect(() => {
  //   if (idOcorrencia) {
  //     history.push({
  //       pathname: "/app/ocorrencia/form",
  //       state: { itemKey: idOcorrencia },
  //     });
  //   }
  // }, [history, idOcorrencia]);

  useEffect(() => {
    if (sqTipoOcorrencia > 0) {
      consultaFormRequest(apiRoutes.fiscalizacao.parametrizacao.consultarOcorrencia, { sequencial: sqTipoOcorrencia });
    } else if (state && state.itemKey) {
      consultaFormRequest(apiRoutes.fiscalizacao.parametrizacao.consultarOcorrencia, { sequencial: state.itemKey });
      delete state.itemKey;
    }
  }, [consultaFormRequest, state, sqTipoOcorrencia]);

  useEffect(() => {
    if ((!consultaFormData && !consultaFormErrors) || consultaFormIsLoading) return;

    if (consultaFormData) {
      const info = {
        codigo: consultaFormData?.result[0]?.sequencialRoteiro,
        data: {
          documentoInclusao: consultaFormData?.result[0]?.usuarioInclusao,
          nomeFormalInclusao: consultaFormData?.result[0]?.nomeFormalInclusao,
          nomeFormalAlteracao: consultaFormData?.result[0]?.nomeFormalAlteracao,
          documentoAlteracao: consultaFormData?.result[0]?.usuarioAlteracao,
          dataInclusao: consultaFormData?.result[0]?.dataInclusao,
          dataAlteracao: consultaFormData?.result[0]?.dataAlteracao,
        },
      };

      setDadosInfo(info);

      setDados(consultaFormData.result[0]);
    }

    if (consultaFormErrors) {
      toast.error(consultaFormErrors.message);
    }
  }, [consultaFormData, consultaFormErrors, consultaFormIsLoading]);

  return (
    <>
      {texto}
      <h1 className="h3 mb-4 text-gray-800">Ocorrência - Detalhes</h1>
      <div className="row">
        <div className="col-lg-12">
          <div className="card shadow mb-4">
            <div className="card-header py-3">
              <Row>
                <Col sm="11">
                  <h6 className="m-0 font-weight-bold text-primary flex-grow-1">
                    Detalhes da Ocorrência Nº <strong>{dados?.sqTipoOcorrencia}</strong>
                  </h6>
                </Col>
                <Col sm="1" className="text-right">
                  <OverlayInfoAdicional data={dadosInfo} keyFieldName="codigo" />
                </Col>
              </Row>
            </div>

            <div className="card-body">
              <Row>
                <Col sm={12} md={3}>
                  <p>
                    Nº da Ocorrência <br />
                    <strong>{dados?.sqTipoOcorrencia}</strong>
                  </p>
                </Col>
                <Col sm={12} md={3}>
                  <p>
                    Tributo
                    <br />
                    <strong>
                      {dados?.sqTributo} - {dados?.dsTributo}
                    </strong>
                  </p>
                </Col>
                <Col sm={12} md={3}>
                  <p>
                    Situação
                    <br />
                    <strong>{dados?.dsStatus === "D" ? "Disponível" : "Revisão"}</strong>
                  </p>
                </Col>
              </Row>
              <Row>
                <Col sm={12} md={12}>
                  <p>
                    {" "}
                    Texto
                    <br />
                    <div>
                      <HtmlToString html={dados?.txTipoOcorrencia} />
                    </div>
                  </p>
                </Col>
              </Row>
              <Row>
                <Col sm={12} md={12}>
                  <p>
                    {" "}
                    Descrição
                    <br />
                    <div>
                      <HtmlToString html={dados?.dsTipoOcorrencia} />
                    </div>
                  </p>
                </Col>
              </Row>
              <Row>
                <Col sm={12} md={6}>
                  <p>
                    {" "}
                    Orientação
                    <br />
                    <div>
                      <HtmlToString html={dados?.txOrientacao} />
                    </div>
                  </p>
                </Col>
                <Col sm={12} md={6}>
                  <p>
                    {" "}
                    Palavra-Chave
                    <br />
                    <div>
                      <HtmlToString html={dados?.txPalavraChave} />
                    </div>
                  </p>
                </Col>
              </Row>
              <Row>
                <Col sm={12} md={10}>
                  <p>
                    {" "}
                    Resumo
                    <br />
                    <div>
                      <HtmlToString html={dados?.txResumo} />
                    </div>
                  </p>
                </Col>
              </Row>
              <Row>
                <Col sm={12} md={6}>
                  <p>
                    {" "}
                    Infringência
                    <br />
                    <div>
                      <HtmlToString html={dados?.txInfrigencia} />
                    </div>
                  </p>
                </Col>
                <Col sm={12} md={6}>
                  <p>
                    {" "}
                    Complemento de Infringência
                    <br />
                    <div>
                      <HtmlToString html={dados?.txCompInfrigencia} />
                    </div>
                  </p>
                </Col>
              </Row>
              <Row>
                <Col sm={12} md={6}>
                  <p>
                    {" "}
                    Penalidade
                    <br />
                    <div>
                      <HtmlToString html={dados?.txPenalidade} />
                    </div>
                  </p>
                </Col>
                <Col sm={12} md={6}>
                  <p>
                    {" "}
                    Complemento da Penalidade
                    <br />
                    <div>
                      <HtmlToString html={dados?.txCompPenalidade} />
                    </div>
                  </p>
                </Col>
              </Row>
              <Row>
                <Col sm={12} md={3}>
                  <p>
                    {" "}
                    Ativo Fixo/Consumo
                    <br />
                    <strong>{dados?.fgAtivoConsumo === "S" ? "SIM" : "NÃO"}</strong>
                  </p>
                </Col>
                <Col sm={12} md={3}>
                  <p>
                    {" "}
                    Permite Agregado
                    <br />
                    <strong>{dados?.fgAgregado === "S" ? "SIM" : "NÃO"}</strong>
                  </p>
                </Col>
                <Col sm={12} md={3}>
                  <p>
                    {" "}
                    Dá Direito a crédito
                    <br />
                    <strong>{dados?.fgDireitoCredito === "S" ? "SIM" : "NÃO"}</strong>
                  </p>
                </Col>
                <Col sm={12} md={3}>
                  <p>
                    {" "}
                    Sentido Operação
                    <br />
                    <strong>{dados?.tpSentidoOperacao === "S" ? "SIM" : "NÃO"}</strong>
                  </p>
                </Col>
              </Row>
              <Row>
                <Col sm={12} md={3}>
                  <p>
                    {" "}
                    Tipo de Mercadoria
                    <br />
                    <strong>{fcTipoMercadoria(dados?.tpMercadoria)}</strong>
                  </p>
                </Col>
                <Col sm={12} md={3}>
                  <p>
                    {" "}
                    Cálculo da Multa
                    <br />
                    <strong>{dados?.sqObrigacao !== 0 ? `${dados?.sqObrigacao} - ${dados?.dsObrigacao}` : "-"}</strong>
                  </p>
                </Col>
                <Col sm={12} md={3}>
                  <p>
                    {" "}
                    Tipo de Detalhamento
                    <br />
                    <strong>
                      {dados?.sqTipoDetalhamento} - {dados?.txDetalhamento}
                    </strong>
                  </p>
                </Col>
                <Col sm={12} md={3}>
                  <p>
                    {" "}
                    Modelo de Importação
                    <br />
                    <strong>
                      {dados?.sqModeloImportacao !== 0
                        ? `${dados?.sqModeloImportacao} - ${dados?.dsModeloImportacao}`
                        : "-"}
                    </strong>
                  </p>
                </Col>
              </Row>
              <Row>
                <Col sm={12} md={3}>
                  <p>
                    {" "}
                    Tipo de Divergência
                    <br />
                    <strong>
                      {dados?.sqTipoAutomacao !== 0 ? `${dados?.sqTipoAutomacao} - ${dados?.dsTipoAutomacao}` : "-"}
                    </strong>
                  </p>
                </Col>
              </Row>

              <Row style={{ marginTop: "30px" }}>
                <Col sm="10">
                  {sqTipoOcorrencia === 0 && (
                    <Button
                      variant="light"
                      onClick={() => history.push({ pathname: "/app/ocorrencia", state: history.location.pathname })}
                    >
                      Voltar
                    </Button>
                  )}

                  {sqTipoOcorrencia > 0 && (
                    <Button variant="light" onClick={handleVoltar}>
                      Voltar
                    </Button>
                  )}
                  {
                    dados?.dsStatus === "R" ? (
                      <>
                        {/* <Button
                        variant="warning"
                        onClick={() => {
                          history.push({
                            pathname: "/app/ocorrencia/form",
                            state: { itemKey: dados.sqTipoOcorrencia },
                          });
                        }}
                      >
                        Revisar
                      </Button> */}
                        {"    "}
                        {/* <Button
                        variant="danger"
                        onClick={() => {
                          Revisar(dados.sqTipoOcorrencia, "D");
                        }}
                      >
                        Cancelar Revisão
                      </Button>
                      {"    "} */}
                        {/* <Button
                        variant="primary"
                        onClick={() => {
                          Revisar(dados.sqTipoOcorrencia, "D");
                        }}
                      >
                        Disponibilizar
                      </Button> */}
                      </>
                    ) : null
                    // <Button
                    //   variant="warning"
                    //   onClick={() => {
                    //     Revisar(dados.sqTipoOcorrencia, "R");
                    //     history.push({
                    //       pathname: "/app/ocorrencia/form",
                    //       state: { itemKey: dados.sqTipoOcorrencia },
                    //     });
                    //   }}
                    // >
                    //   Revisar
                    // </Button>
                  }

                  {/* <Button
                    variant="primary"
                    onClick={() => {
                      Clonar(dados.sqTipoOcorrencia);
                    }}
                  >
                    Clonar
                  </Button>  */}
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ConsultaOcorrenciaDetalhes;
